import { Button } from '@makyoapp/makyo-ui'

import { useSyncDetailPages } from '@/hooks/useSyncDetailPages'

import { DetailsPageSyncModal } from './layout/DetailsPageSyncModal'

/**
 * Page Sync Component
 */
export const PageSync = () => {
  // sync detail pages
  const { syncState, handleReset, simulateSync } = useSyncDetailPages()

  return (
    <>
      {/*//? DEBUG */}
      {/* <div className='flex gap-2 p-4'>
        <Button onClick={() => simulateSync('none')}>Simulate Success</Button>
        <Button onClick={() => simulateSync('delete')}>Simulate Delete Error</Button>
        <Button onClick={() => simulateSync('add')}>Simulate Add Error</Button>
        <Button onClick={() => simulateSync('both')}>Simulate Both Errors</Button>
      </div> */}

      <DetailsPageSyncModal syncState={syncState} onFinish={handleReset} />
    </>
  )
}
